import type { Currency } from '@navio/nsdk';
import { NoddiDateFormats, noddiFormatDate } from 'noddi-util';

import { isCampaignClaimDeadlineExpired } from './campaignClaimDeadline';
import type { CampaignClaimDeadline, CustomerClaimDiscount } from './customerClaimDiscount';

export type CampaignCouponTemplateLike = {
  id: string | number;
  namePublic: string;
  descriptionPublic?: string | null;
  discount?: { amount: number; currency: Currency } | null;
  discountPercentage?: number | null;
  expiryDaysAfterReceiving?: number | null;
  validForBrands?: { id: number; name: string; logo?: { url: string } | null }[];
};

export const buildCampaignClaimDeadline = (
  expiresAt: string | null | undefined,
  formatLabel: (args: { isExpired: boolean; formattedDate: string }) => string
): CampaignClaimDeadline | null => {
  if (expiresAt == null || expiresAt === '') {
    return null;
  }
  const isExpired = isCampaignClaimDeadlineExpired(expiresAt);
  const formattedDate = noddiFormatDate(expiresAt, NoddiDateFormats.DATE);
  return {
    isExpired,
    label: formatLabel({ isExpired, formattedDate })
  };
};

export const mapCouponTemplatesToClaimDiscounts = (
  templates: CampaignCouponTemplateLike[],
  formatValidityHint: (expiryDaysAfterReceiving: number | null | undefined) => string | undefined
): CustomerClaimDiscount[] =>
  templates.map((template) => ({
    id: template.id,
    namePublic: template.namePublic,
    descriptionPublic: template.descriptionPublic ?? undefined,
    discountAmount: template.discount?.amount,
    currency: template.discount?.currency,
    discountPercentage: template.discountPercentage ?? undefined,
    validityHint: formatValidityHint(template.expiryDaysAfterReceiving),
    validForBrands: template.validForBrands?.map((brand) => ({
      id: brand.id,
      name: brand.name,
      logoUrl: brand.logo?.url
    }))
  }));
